import type {
  DriverMetricAdjustmentEventType,
  DriverMetricAdjustmentMetricType,
  DriverMetricAdjustmentStatus,
  SearchDriverStatus
} from '@/backend/market'

export class DriverMetricAdjustmentEventEntity {
  id?: string
  eventType?: DriverMetricAdjustmentEventType
  resultingStatus?: DriverMetricAdjustmentStatus
  actorUserId?: string
  relatedAdjustmentId?: string | null
  details?: string | null
  createdAt?: string
}

export class DriverMetricAdjustmentEntity {
  id?: string
  driverId?: number
  regionId?: number
  metricType?: DriverMetricAdjustmentMetricType
  status?: DriverMetricAdjustmentStatus
  reason?: string | null
  idempotencyKey?: string | null
  createdByUserId?: string
  createdAt?: string
  recordDates?: string[] | null
  searchDriverId?: string | null
  effectiveStatus?: SearchDriverStatus
  driverShiftId?: string | null
  startAt?: string | null
  endAt?: string | null
  events?: DriverMetricAdjustmentEventEntity[] | null
}
